// Mock data for Zedworx Consultancy

export const services = [
  {
    id: 1,
    title: "Fiscal Oversight",
    description: "Monitoring Government Fiscal Matters that Impact Business. Track National Treasury budget processes, tax policy changes, and fiscal policy developments across all sectors.",
    icon: "file-search",
    expandedContent: {
      reports: [
        { title: "Financial Legislation Impacting SA Business & Society (December 2025)", type: "PDF", link: "/reports/Financial-Legislation-December-2025.pdf" },
        { title: "National Budget Analysis & Business Impact 2024/25 - ATTACH PDF", type: "PDF", link: "#" },
        { title: "Tax Policy Changes Quarterly Review - ATTACH PDF", type: "PDF", link: "#" }
      ],
      analysis: "Year-round tracking of National Treasury fiscal policies, budget processes, and tax legislation. We monitor Budget Speech developments, Medium Term Budget Policy Statements, Division of Revenue allocations, and fiscal policy changes affecting business operations across all sectors.",
      caseStudy: {
        title: "Multi-Sector Client - Fiscal Intelligence",
        preview: "Delivered comprehensive fiscal intelligence tracking budget allocations and tax policy changes across health, manufacturing, and infrastructure sectors, supporting strategic business planning."
      },
      insights: [
        "Budget process tracking from allocation to implementation",
        "Tax policy and regulatory changes",
        "Cross-sector fiscal impact analysis"
      ]
    }
  },
  {
    id: 2,
    title: "Health Care & Health Services",
    description: "Comprehensive legislative intelligence for health care services, monitoring policy changes, budget allocations, and regulatory developments affecting medical providers and health-related businesses.",
    icon: "heart-pulse",
    expandedContent: {
      reports: [
        { title: "Health Services Oversight 2025-26", type: "PDF", link: "/reports/Health-Services-Oversight-2025-26.pdf" },
        { title: "National Health Insurance Budget Analysis 2024 - ATTACH PDF", type: "PDF", link: "#" },
        { title: "Health Committee BRRS Report Q4 2024 - ATTACH PDF", type: "PDF", link: "#" }
      ],
      analysis: "We provide year-round monitoring of health sector legislation, budget votes, committee oversight activities, and regulatory changes. Our intelligence covers NHI developments, pharmaceutical regulations, medical aid scheme policies, and provincial health budgets.",
      caseStudy: {
        title: "Health Sector Client - Regulatory Intelligence",
        preview: "Provided comprehensive tracking of National Health Insurance legislation and regulatory developments, enabling strategic planning for healthcare service providers and medical aid schemes."
      },
      insights: [
        "Real-time alerts on health policy changes",
        "Committee oversight tracking for health budgets",
        "Pharmaceutical regulation monitoring"
      ]
    }
  },
  {
    id: 3,
    title: "Manufacturing: Tobacco, Food, & Beverages",
    description: "Strategic intelligence for tobacco, food, and beverage industries. Track regulatory changes, excise duties, product standards, and trade policies affecting manufacturing operations.",
    icon: "building",
    expandedContent: {
      reports: [
        { title: "Tobacco Industry & Health Services", type: "PDF", link: "/reports/Tobacco-Industry-Health-Services.pdf" },
        { title: "Taxation: Inflation Effect Manufacturing (August 2025)", type: "PDF", link: "/reports/Taxation-Inflation-Effect-Manufacturing-August-2025.pdf" },
        { title: "SAB ABinBev Condensed Report (August 2025)", type: "PDF", link: "/reports/SAB-ABinBev-Condensed-Report-August-2025.pdf" }
      ],
      analysis: "Meticulous tracking of legislation and oversight affecting tobacco, food, and beverage manufacturing. We monitor product control laws, labeling requirements, excise duty changes, trade regulations, and industry-specific compliance requirements.",
      caseStudy: {
        title: "Thompson Trust Partnership - Legislative Intelligence",
        preview: "Delivered critical intelligence on tobacco regulation and food safety legislation, supporting strategic advisory work for major manufacturing clients facing regulatory changes."
      },
      insights: [
        "Excise duty and taxation tracking",
        "Product control and labeling requirements",
        "Trade policy developments"
      ]
    }
  }
];

export const clientIndustries = [
  {
    id: 1,
    name: "Health Care Services",
    description: "Comprehensive regulatory compliance and legislative tracking for healthcare providers, pharmaceutical companies, and medical aid schemes.",
    icon: "heart-pulse"
  },
  {
    id: 2,
    name: "Tobacco Industry",
    description: "Legislative oversight and compliance tracking for tobacco sector businesses.",
    icon: "cigarette"
  },
  {
    id: 3,
    name: "Water & Sanitation",
    description: "Policy tracking for water utilities, sanitation services, and environmental compliance providers.",
    icon: "droplet"
  },
  {
    id: 4,
    name: "Food & Beverages",
    description: "Regulatory intelligence for food manufacturing and beverage distribution companies.",
    icon: "apple"
  },
  {
    id: 5,
    name: "Provincial & Municipal Governance",
    description: "Intelligence on provincial and local government policies, budget allocations, and service delivery oversight.",
    icon: "map-pin"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Smart Work & Extensive Experience",
    description: "We work hard and smart. Our team brings over 40 years of government expertise, including 24 years of hands-on experience in legislative & executive operations. Unmatched practical insight into South African parliamentary processes.",
    icon: "brain",
    expandedContent: {
      reports: [],
      analysis: "Our senior team members have worked directly within government and legislative operations for over 40 years combined, with 24 years specifically in parliamentary and legislative environments. This deep immersion provides clients with insights that only come from firsthand experience in South African government processes.",
      caseStudy: {
        title: "Historical Legislative Analysis - Regulatory Evolution",
        preview: "Leveraged 40 years of government expertise to provide comprehensive historical analysis of regulatory evolution across multiple sectors, demonstrating institutional memory and deep understanding of legislative precedents."
      },
      insights: [
        "Institutional memory of government processes",
        "Direct relationships with parliamentary structures",
        "Understanding of procedural precedents and practices"
      ]
    }
  },
  {
    id: 2,
    title: "Meticulous Tracking",
    description: "Comprehensive monitoring of legislative and oversight developments that impact business sectors.",
    icon: "search-check",
    expandedContent: {
      reports: [
        { title: "Legislative Tracking Methodology Framework", type: "PDF", link: "#" },
        { title: "Committee Oversight Monitoring Process", type: "PDF", link: "#" },
        { title: "Budget Cycle Tracking System Overview", type: "PDF", link: "#" }
      ],
      analysis: "Our meticulous tracking methodology ensures no legislative development goes unnoticed. We monitor Budget Votes, Quarterly Performance Reports, committee meetings, oversight visits, and resolutions affecting your sector. Every document, every committee meeting, every policy shift is tracked and analysed.",
      caseStudy: {
        title: "Manufacturing Sector - Comprehensive Tracking",
        preview: "Tracked 47 committee meetings, 12 oversight visits, and 8 BRRS reports affecting tobacco and food regulation, providing complete intelligence coverage throughout the legislative year."
      },
      insights: [
        "Comprehensive parliamentary tracking",
        "Committee meeting and resolution monitoring",
        "Budget process documentation"
      ]
    }
  },
  {
    id: 3,
    title: "Timely Legislative Intelligence",
    description: "Stay ahead of the curve. Our Legislative Intelligence Methodologies guarantee regular updates on policy changes, ensuring your business is ready for regulatory shifts.",
    icon: "clock",
    expandedContent: {
      reports: [
        { title: "Real-Time Intelligence Delivery Framework", type: "PDF", link: "#" },
        { title: "Early Warning System Methodology", type: "PDF", link: "#" },
        { title: "Policy Change Alert Protocols", type: "PDF", link: "#" }
      ],
      analysis: "We provide timely intelligence through regular briefings, real-time alerts, and comprehensive reports. Our early warning systems identify potential legislative changes before they become Bills, giving you maximum time to prepare strategic responses.",
      caseStudy: {
        title: "Health Sector Client - Early Intelligence",
        preview: "Provided early warning of National Health Insurance regulatory changes 6 months before formal tabling, enabling strategic positioning and stakeholder engagement preparation."
      },
      insights: [
        "Real-time policy change alerts",
        "Pre-emptive legislative intelligence",
        "Regular briefing schedules"
      ]
    }
  },
  {
    id: 4,
    title: "Proven Client Service Track Record",
    description: "ZEDWORX has a history of providing critical support to trusted consultancy firms, such as Thompson Trust, delivering high-level intelligence for strategic decisions.",
    icon: "lightbulb",
    expandedContent: {
      reports: [
        { title: "January 2026 Client Report - Thompson Trust", type: "PPTX", link: "/reports/January-2026-Client-Report.pptx" },
        { title: "Analysis SONA 12 Feb 2026 - Key Business Clients TT", type: "PDF", link: "/reports/Analysis-SONA-12-Feb-2026.pdf" }
      ],
      analysis: "Our track record spans health, manufacturing, essential services, infrastructure, and fiscal oversight. We've supported consultancy firms, industry associations, and corporate clients with timely, accurate legislative and budget intelligence informing critical strategic decisions.",
      caseStudy: {
        title: "Thompson Trust Partnership Overview",
        preview: "Multi-year partnership delivering legislative and fiscal intelligence supporting Thompson Trust's advisory work across health, manufacturing, and tobacco sectors. Our intelligence informed strategy recommendations for clients managing significant sector exposure."
      },
      insights: [
        "Cross-sector intelligence delivery",
        "Consultancy firm partnership model",
        "Strategic intelligence driving business decisions"
      ]
    }
  }
];

export const stats = [
  { label: "Broad Business Sectors Tracked", value: "3+" },
  { label: "Industries Served", value: "5+" },
  { label: "Years in Business", value: "5+" },
  { label: "Years Combined Expertise", value: "40+" }
];

export const contactFormSubmit = (formData) => {
  // Mock API call - simulates form submission
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Form submitted:", formData);
      resolve({
        success: true,
        message: "Thank you for your inquiry. We'll get back to you within 24 hours."
      });
    }, 1000);
  });
};
